import { type FC } from 'react';

import { useBlocks } from '../hooks/use-blocks';
import { useJsonLdRenderer } from '../hooks/use-json-ld-renderer';
import { useMetaRenderer } from '../hooks/use-meta-renderer';
import { useRouteInterceptor } from '../hooks/use-route-interceptor';
import { useScrollToLocation } from '../hooks/use-scroll-to-location';

import { BlockRenderer } from './block-renderer';

export const PageRenderer: FC = () => {
    const { blocks, breadcrumbs } = useBlocks();

    useJsonLdRenderer({ jsonld: { breadcrumbs } });

    useRouteInterceptor();

    useMetaRenderer();

    useScrollToLocation();
    return <BlockRenderer blocks={blocks} />;
};
